import { toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/import-close.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-075fef0a")

_pushScopeId("data-v-075fef0a")
const _hoisted_1 = { class: "import" }
const _hoisted_2 = { class: "header display-flex justify-content-between" }
const _hoisted_3 = { class: "loading-content display-flex align-items-center" }
const _hoisted_4 = { class: "import-title" }
const _hoisted_5 = { class: "margin-left5px import-title" }
const _hoisted_6 = {
  key: 1,
  class: "margin-left5px import-title"
}
const _hoisted_7 = { class: "arrow-content display-flex align-items-center" }
const _hoisted_8 = { class: "import-item-msg" }
const _hoisted_9 = { class: "display-flex align-items-center" }
const _hoisted_10 = { style: {"margin-right":"5px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_import_progress = _resolveComponent("import-progress")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_import_detail_dialog = _resolveComponent("import-detail-dialog")
  const _component_error_dialog = _resolveComponent("error-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.importStatus==='loading' || _ctx.importStatus ==='loadingWarn')
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$wordList.ProperAllTextImporting), 1),
              _createVNode("p", _hoisted_5, _toDisplayString(`${_ctx.faceTaskList.CompletedTaskNum}/${_ctx.faceTaskList.Total}`), 1)
            ], 64))
          : (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.$wordList.ImportComplete), 1)),
        _createVNode("img", {
          src: _ctx.statusIcon[_ctx.importStatus],
          class: "margin-left25px"
        }, null, 8, ["src"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("img", {
          src: require(_ctx.unfold?'@/assets/image/import-unfold.png':'@/assets/image/import-fold.png'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.unfold=!_ctx.unfold))
        }, null, 8, ["src"]),
        _createVNode("img", {
          src: _imports_0,
          class: "margin-left25px",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
        })
      ])
    ]),
    _createVNode(_component_el_scrollbar, null, {
      default: _withId(() => [
        _createVNode("ul", {
          class: "import-content",
          style: {height: _ctx.unfold ? '0px' : _ctx.contentHeight + 'px'},
          ref: "ulRef"
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.faceTaskList.List, (item) => {
            return (_openBlock(), _createBlock("li", {
              class: "import-item display-flex align-items-center",
              key: item.ID
            }, [
              _createVNode("img", {
                src: item.Type==='face'?require('@/assets/image/import-zip.png'):require('@/assets/image/import-icon.png')
              }, null, 8, ["src"]),
              _createVNode("div", _hoisted_8, [
                _createVNode("p", null, _toDisplayString(item.OldFileName), 1),
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_import_progress, {
                    percent: Number(item.Progress),
                    status: item.Status==='1'?'success':'warn'
                  }, _createSlots({ _: 2 }, [
                    (item.Status==='2' || item.Status==='4')
                      ? {
                          name: "warn",
                          fn: _withId(() => [
                            _createVNode("label", _hoisted_10, _toDisplayString(`${item.ErrorTaskNum} ${_ctx.$wordList.Failed}`), 1)
                          ])
                        }
                      : undefined
                  ]), 1032, ["percent", "status"]),
                  _withDirectives(_createVNode("div", {
                    class: "error-detail",
                    onClick: ($event: any) => (_ctx.showDetail(item))
                  }, _toDisplayString(_ctx.$wordList.Details), 9, ["onClick"]), [
                    [_vShow, item.Status==='2' || item.Status==='4']
                  ])
                ])
              ])
            ]))
          }), 128))
        ], 4)
      ]),
      _: 1
    }),
    (_ctx.isShowDetailDialog)
      ? (_openBlock(), _createBlock(_component_import_detail_dialog, {
          key: 0,
          "task-id": _ctx.taskInfoId,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowDetailDialog=false))
        }, null, 8, ["task-id"]))
      : _createCommentVNode("", true),
    (_ctx.isShowErrorInfoDialog)
      ? (_openBlock(), _createBlock(_component_error_dialog, {
          key: 1,
          details: _ctx.taskErrorInfo,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowErrorInfoDialog=false))
        }, null, 8, ["details"]))
      : _createCommentVNode("", true)
  ]))
})